// Customer related endpoints
export const customerEndpoints = (builder) => ({
  // Customer CRUD operations
  // getCustomers: builder.query({
  //   query: (payload) => ({
  //     url: '/common/get-customer',
  //     method: 'POST',
  //     body: payload,
  //   }),
  //   providesTags: ['Customer'],
  // }),

  getCustomers: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      // Add searchTerm and searchValue only if they are defined and not null
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }

      return {
        url: '/common/get-customer',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Customer'],
  }),

  getCustomerById: builder.query({
    query: (id) => ({
      url: `/common/get-customerById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Customer', id }],
  }),

  saveCustomer: builder.mutation({
    query: (data) => ({
      url: '/common/save-customer',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Customer'],
  }),

  deleteCustomer: builder.mutation({
    query: (id) => ({
      url: `/common/customer/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Customer'],
  }),

  bulkDeleteCustomers: builder.mutation({
    query: (ids) => ({
      url: '/common/customers/bulk-delete',
      method: 'POST',
      body: { ids },
    }),
    invalidatesTags: ['Customer'],
  }),
});
